import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const reduce = useReducedMotion();
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="mx-auto w-full max-w-xl rounded-2xl border border-danger/30 bg-dangersoft p-4" data-id="element-322" data-mp="2sz24d2jb6t7g">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-bold text-danger" data-id="element-323" data-mp="37w1asn2fcg0c">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-324" data-mp="32yj83ef02x0s" />
        Only {SPOTS_LEFT} spots left at the promotional price!
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-325" data-mp="3gr8xztxngm36">
        <motion.div className="h-full rounded-full bg-danger" initial={reduce ? {
        width: `${filled}%`
      } : {
        width: "40%"
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-326" data-mp="3lpagacn94hdl" />
      </div>
      <div className="mt-2 flex justify-between text-xs font-semibold text-ink/70" data-id="element-327" data-mp="18e9c9biz07ho">
        <span data-id="element-328" data-mp="1ci7alk0h1e9o">{Math.round(filled)}% claimed</span>
        <span data-id="element-329" data-mp="1hgiktvuohqsf">
          {SPOTS_LEFT} of {TOTAL_SPOTS} remaining
        </span>
      </div>
    </div>;
}